let UNDEF;export default(a=>{let b={maxOnly:(a,b,c,d=[],e)=>{let f,g=c[b].value,h=b;for(let j=b-1;j>=a;--j)f=d[j]===UNDEF?c[j].value:d[j],f>g&&(g=f,h=j);return e.push(h),e},minMax:(a,b,c,d=[],e)=>{let f,g=c[b].value,h=b,j=c[b].value,k=b;for(let l=b-1;l>=a;--l)f=d[l]===UNDEF?c[l].value:d[l],f>g?(g=f,h=l):f<j&&(j=f,k=l);return[k,h]=k<h?[k,h]:[h,k],e.push(k),k!==h&&e.push(h),e}};return b[a]||b.maxOnly});


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-features/src/data-skipping/data-skipping-filters.js
// module id = null
// module chunks = 